<template>
  <div class="dialogboxB">
    <div class="tip right" v-show="showPartyChild">
      <div style="display:flex;flex-direction:column">
        <div class="body" @mouseover="changeActive(0)" @mouseout="removeActive(1)" @click="towailianB">
          <img src="@/assets/image/sk1.png" class="oneImg" v-show="chooseValue == 1" />
          <img src="@/assets/image/sk2.png" class="oneImg" v-show="chooseValue != 1" />
          <div :class="[chooseValue == 1 ? 'titleFont' : 'titleFontHover']">
            散客购票
          </div>
        </div>
        <div class="body" style="margin-top:2.3148vh" @mouseover="changeActiveHover(0)" @mouseout="removeActive(1)" @click="towailianA">
          <img src="@/assets/image/lx1.png" class="twoImg" v-show="hoverValue == 1" />
          <img src="@/assets/image/lx2.png" class="twoImg" v-show="hoverValue != 1" />
          <div :class="[hoverValue == 1 ? 'titleFont' : 'titleFontHover']">
            旅行社购票
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="tip top">top</div>
    <div class="tip bottom">bottom</div>
    <div class="tip left">left</div> -->
</template>

<script>
import { getLinkList } from "@/api/common";
export default {
  name: "dialogboxB",
  components: {},
  props: ["showParty"],
  data() {
    return {
      chooseValue: 1,
      hoverValue: 1,
      showPartyChild: false,
      wailianA: "",
      wailianB: ""
    };
  },
  watch: {
    showParty(newName, oldName) {
      this.showPartyChild = newName;
    }
  },
  mounted() {
    this.getInfoFunction();
    this.showPartyChild = this.showParty;
  },
  methods: {
    changeActive(type) {
      this.chooseValue = type;
      this.hoverValue = 1;
    },
    changeActiveHover(type) {
      this.hoverValue = type;
      this.chooseValue = 1;
    },
    removeActive(type) {
      this.chooseValue = 1;
      this.hoverValue = 1;
      this.$emit("mouseOut");
    },
    async getInfoFunction() {
      const { code, data } = await getLinkList();
      if (code == 200) {
        this.wailianA = data[0].url;
        this.wailianB = data[1].url;
      }
    },
    towailianA() {
      window.open(this.wailianA, "_blank");
    },
    towailianB() {
      window.open(this.wailianB, "_blank");
    }
  }
};
</script>

<style scoped>
.dialogboxB {
  position: absolute;
  z-index: 11;
  top: -1.8518vh;
  right: 4.583vw;
}
.dialogboxB .body {
  margin-left: 1.04167vw;
  margin-top: 1.944vh;
}
.dialogboxB .oneImg {
  width: 0.9895vw;
  height: 2.222vh;
  float: left;
}
.dialogboxB .twoImg {
  width: 0.9895vw;
  height: 2.222vh;
  float: left;
}
.dialogboxB .titleFont {
  font-size: 1.2962vh;
  font-weight: 400;
  color: #333333;
  font-family: "Microsoft YaHei";
  margin-left: 0.46875vw;
  float: left;
  line-height: 1.111vh;
  margin-top: 0.4629vh;
}
.dialogboxB .titleFontHover {
  font-size: 1.2962vh;
  font-weight: 400;
  color: #0f7d72;
  font-family: "Microsoft YaHei";
  margin-left: 0.46875vw;
  float: left;
  line-height: 1.111vh;
  margin-top: 0.4629vh;
}

.tip {
  position: relative;
  margin: 1.8518vh auto;
  color: white;
  text-align: center;
  border-radius: 10px;
  font-family: sans-serif;
  width: 9.635vw;
  height: 10.37037vh;
  background: #ffffff;
  box-shadow: 0px 2px 7px 0px rgba(7, 49, 45, 0.63);
  border-radius: 6px;
}
.tip:after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  border: 0.7407vh solid;
}
.top:after {
  border-bottom-color: deepskyblue;
  left: 50%;
  bottom: 100%;
  margin-left: -0.78125vw;
}
.right:after {
  border-left-color: #ffffff;
  border-right-color: rgba(255, 255, 255, 0);
  border-top-color: rgba(255, 255, 255, 0);
  border-bottom-color: rgba(255, 255, 255, 0);
  left: 100%;
  top: 50%;
  margin-top: -0.3645vw;
}
.bottom:after {
  border-top-color: deepskyblue;
  top: 100%;
  left: 50%;
  margin-left: -0.78125vw;
}
.left:after {
  border-right-color: deepskyblue;
  top: 50%;
  right: 100%;
  margin-top: -0.46875vw;
}
</style>



// WEBPACK FOOTER //
// src/components/common/arrowDialogBoxB.vue